import React from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';

import { getLabel } from './utils';

import './form.scss';

const TextArea = React.forwardRef(({ label, error, hint, required, ...inputProps }, ref) => {
    const hasError = error && error.length > 0;
    const inputClasses = classNames({
        'ml-form-field': true,
        'error': hasError,
    });

    label = getLabel(label, inputProps.name, required);

    return (
        <div className={inputClasses}>
            <label>
                <span>{label}</span>
                <textarea key="input" ref={ref} {...inputProps} />
                { hint && <div key="hint" className="ml-form-field-helptext">{ hint }</div> }
                { hasError && <div key="error" className="ml-form-field-errortext">{ error }</div> }
            </label>
        </div>
    );
});

TextArea.propTypes = {
    label: PropTypes.string,
    error: PropTypes.string,
    hint: PropTypes.string,
    required: PropTypes.bool,
};

export default TextArea;
